import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import {
  BehaviorSubject,
  catchError,
  map,
  Observable,
  tap,
  throwError,
} from 'rxjs';

import { withNoMessageToast } from '../interceptors/http-toast.interceptor';
import { RoleType } from './role.service';
import { environment } from '../../../environments/environment';
export interface User {
  userId: string;
  fullName: string;
  email: string;
  role: {
    _id: string;
    name: string;
  };
  employeeId?: string;
  clientId?: string;
}
@Injectable({
  providedIn: 'root',
})
export class UserService {
  private userSubject = new BehaviorSubject<User | null>(null);
  user$ = this.userSubject.asObservable();
  userLoaded = new BehaviorSubject<boolean>(false);
  userLoaded$ = this.userLoaded.asObservable();
  routeToRedirectWithPermission = signal<string | null>('/');
  constructor(private http: HttpClient) {}

  getProfile(): Observable<User> {
    // console.log("Fetching user profile...");
    return this.http
      .get<User>(`${environment.baseApiUrl}/api/auth/me`, {
        context: withNoMessageToast(),
      })
      .pipe(
        tap((user) => {
          //console.log("User profile fetched successfully:", user);

          if (user) {
            switch (user.role.name) {
              case RoleType.Admin:
                this.routeToRedirectWithPermission.set('/dashboard');
                break;
              case RoleType.Employee:
                this.routeToRedirectWithPermission.set('/timesheets/');
                break;
              case RoleType.Client:
                this.routeToRedirectWithPermission.set('/invoices/');
                break;
            }
          }
          this.userSubject.next(user);
          this.userLoaded.next(true);
        }),
        catchError((e) => {
          this.userSubject.next(null);
          this.userLoaded.next(false);
          console.error('Error fetching user profile:', e);

          return throwError(() => e);
        })
      );
  }

  hasRoles$(roles: RoleType[]): Observable<boolean> {
    return this.userSubject.pipe(
      map((user) => (user ? roles.includes(user.role.name as RoleType) : false))
    );
  }
}
